"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = login;
var _axios = _interopRequireDefault(require("axios"));
var _Util = require("../util/Util");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
/**
 * Calls the supplied login endpoint.
 *
 * @param {string} email - The email address of the user to login.
 * @param {string} password - The password of the user to login.
 * @param {string} portalId - The Id of the portal to login at.
 * @param {string} endpoint - The endpoint to call with this method.
 * @param {string} authToken - The (anonymous) authentication token for calling printdeal endpoints
 * @param {string} cartId - The anonymous cartId
 * @param {string} store - The store from the website
 *
 * @returns Axios promise with the token or error
 */
function login(email, password, portalId, endpoint, authToken, cartId, store) {
  var data = _objectSpread({
    email: (0, _Util.formatEmail)(email),
    portalId: portalId,
    password: password,
    store: store
  }, cartId && cartId.length && {
    anonymousCartId: cartId
  });
  return (0, _axios["default"])({
    url: endpoint,
    method: 'POST',
    headers: {
      Authorization: authToken,
      'Content-type': 'application/json'
    },
    data: data,
    withCredentials: true
  });
}